import { DoctorSpecialty } from '@dreryk/egabinet-personnel-frontend-api';

type SpecialtyCellProps = {
   readonly specialties: DoctorSpecialty[];
};

export const SpecialtyCell = (props: SpecialtyCellProps): JSX.Element => {
   return <>{props.specialties.map((specialty) => specialty.medicalSpecialty.name).join(', ')}</>;
};
